import Vue from "vue";
import VueRouter from "vue-router";
import qs from "qs";
import Home from "../views/Home";
import Login from "../views/Login";
import Signup from "../views/Signup";
import PasswordRecovery from "../views/PasswordRecovery";
import PasswordConfirmation from "../views/PasswordConfirmation";
import PasswordEdition from "../views/PasswordEdition";
import Offers from "../views/Offers";
import Product from "../views/Product";
import Universes from "../views/Universes";
import Universe from "../views/Universe";
import PageNotFound from "../views/PageNotFound";
import Search from "../views/Search";
import Cart from "../views/Cart";
import Orders from "../views/Orders";
import Order from "../views/Order";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      title: "Bienvenue"
    }
  },
  {
    path: "/password-confirmation/:token",
    name: "PasswordConfirmation",
    component: PasswordConfirmation
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Connexion"
    }
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: {
      title: "Inscription"
    }
  },
  {
    path: "/password-recovery",
    name: "PasswordRecovery",
    component: PasswordRecovery,
    meta: {
      title: "Mot de passe oublié"
    }
  },
  {
    path: "/password-edit",
    name: "PasswordEdition",
    component: PasswordEdition,
    meta: {
      requiresAuth: true,
      title: "Modification du mot de passe"
    }
  },
  {
    path: "/offers",
    name: "Offers",
    component: Offers,
    meta: {
      requiresAuth: true,
      title: "Offres"
    }
  },
  {
    path: "/products/:id",
    name: "Product",
    component: Product,
    meta: {
      requiresAuth: true,
      title: "Produits"
    }
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/universes",
    name: "Universes",
    component: Universes,
    meta: {
      requiresAuth: true,
      title: "Univers"
    }
  },
  {
    path: "/universes/:id",
    name: "Universe",
    component: Universe,
    meta: {
      requiresAuth: true,
      title: "Univers"
    }
  },
  {
    path: "/universes/:universe_id/products/:id",
    name: "UniverseProduct",
    component: Product,
    meta: {
      requiresAuth: true,
      title: "Univers"
    }
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
    meta: {
      requiresAuth: true,
      title: "Panier"
    }
  },
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
    meta: {
      requiresAuth: true,
      title: "Mes commandes"
    }
  },
  {
    path: "/order/:id",
    name: "Order",
    component: Order,
    meta: {
      requiresAuth: true,
      title: "Commande"
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import(/* webpackChunkName: "profile" */ "../views/Profile"),
    meta: {
      requiresAuth: true,
      title: "Mon profil"
    }
  },
  {
    path: "/my-agent",
    name: "Agent",
    component: () => import(/* webpackChunkName: "agent" */ "../views/Agent"),
    meta: {
      requiresAuth: true,
      title: "Mon captain"
    }
  },
  {
    path: "/cgu-cgv",
    name: "CGU",
    component: () => import(/* webpackChunkName: "cgu" */ "../views/Cgu"),
    meta: {
      title: "Conditions Générales de Vente et d'Utilisation"
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "cgu" */ "../views/About"),
    meta: {
      title: "Qui sommes-nous"
    }
  },
  {
    path: "/cookie-policy",
    name: "Cookies",
    component: () => import(/* webpackChunkName: "cgu" */ "../views/Cookies"),
    meta: {
      title: "Gestion des cookies"
    }
  },
  {
    path: "/not-found",
    name: "NotFound",
    component: PageNotFound,
    meta: {
      requiresAuth: true,
      title: "Page introuvable"
    }
  },
  {
    path: "*",
    redirect: { name: "NotFound" }
  }
];

const router = new VueRouter({
  routes,
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    const result = qs.stringify(query, {
      arrayFormat: "brackets",
      skipNulls: true,
      filter: (prefix, value) => value !== "" ? value : undefined
    });

    return result ? "?" + result : "";
  }
});

router.beforeEach((to, from, next) => {
  const authRouteNames = ["Login", "PasswordRecovery", "PasswordConfirmation", "Signup"];

  const checkAuth = () => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters["auth/isLoggedIn"]) {
        next();

        return;
      }

      next({ name: "Login", query: { redirect: to.path } });
    } else if (
      authRouteNames.includes(to.name)
      && store.getters["auth/isLoggedIn"]
    ) {
      next({ name: "Home" });
    } else {
      next();
    }
  };

  if (store.state.initialized) {
    checkAuth();

    return;
  }

  store.dispatch("initialize").then(() => {
    checkAuth();
  });
});

export default router;
